import {
  Box, FormControlLabel, Radio, RadioGroup, Typography,
} from '@material-ui/core'
import React, { useState, useEffect } from 'react'
import { useOrderContext } from '../../../OrderContext'
import classes from './VoiceServiceCheckoutWarning.styles'

// Bundle with Voice
interface VoiceServiceCheckoutWarningProps {
  onAlternativePhoneChange?: (hasAlternativePhone: boolean) => void;
}

export default function VoiceServiceCheckoutWarning({ 
  onAlternativePhoneChange 
}: VoiceServiceCheckoutWarningProps) {
  const {
    options, setOptions,
  } = useOrderContext()

  const {
    alternativePhone,
  } = options

  const [
    radioValue,
    setRadioValue,
  ] = useState<string>(alternativePhone !== undefined ? (alternativePhone ? 'yes' : 'no') : '')

  const handleRadioChange = (e: React.FormEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value
    setRadioValue(value)

    const hasAlternativePhone = value === 'yes'
    
    setOptions({
      ...options,
      alternativePhone: hasAlternativePhone,
    })

    // Notify parent component about the change
    if (onAlternativePhoneChange) {
      onAlternativePhoneChange(hasAlternativePhone)
    }
  }

  // Initialize radio value based on existing alternativePhone state
  useEffect(() => {
    if (alternativePhone !== undefined) {
      setRadioValue(alternativePhone ? 'yes' : 'no')
    }
  }, [alternativePhone])

  return (
    <>
      <Box className={classes.warningContainer}>
        <Box className={classes.warningContent}>
          <Typography variant="body1" className={classes.warningText}>
            <strong>Our Calls service requires a working broadband connection and electricity to power the phone adaptor</strong>
          </Typography>
          <br/>
          <Typography variant="body1" className={classes.warningText}>
            To proceed with checkout, please select "Yes" if both of the following statements are true
          </Typography>
          <Box component="ol" className={classes.requirementsList}>
            <li>
              <Typography variant="body1">
                I have another way to contact emergency services, such as mobile phone with signal
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                I confirm that I am not using a healthcare or medical alarm that connects to my telephone line
              </Typography>
            </li>
          </Box>
          <RadioGroup
            className={classes.radioGroup}
            aria-labelledby="voice-service-requirements"
            onChange={handleRadioChange}
            value={radioValue}
            row
          >
            <FormControlLabel
              value="yes"
              control={<Radio required color="primary"/>}
              label="Yes"
            />
            <FormControlLabel
              value="no"
              control={<Radio required color="primary"/>}
              label="No"
            />
          </RadioGroup>
        </Box>
      </Box>
    </>
  )
}
